<template>
  <div>
    <v-snackbar v-model="show" right top auto-height color="orange" :timeout="0">
      <div>
        <h2 class="mt-2 mb-4">{{ $t('Client message') }}: {{ value.name }}</h2>
        <p class="my-2" v-html="value.client_message"></p>
      </div>
      <v-btn dark flat @click="show = false">
        {{ $t('OK') }}
      </v-btn>
    </v-snackbar>

    <v-tooltip bottom>
      <v-icon slot="activator" color="orange" :disabled="!value.client_message" @click="show = true">warning</v-icon>
      {{ $t('Client message') }}
    </v-tooltip>
  </div>
</template>

<script type="text/javascript">

export default {
  name: 'settlement-client-message',
  props: ['value'],
  data() {
    return {
      show: false
    }
  },
  watch: {
    'value.client_message'() {
      this.show = true;
    }
  },
  mounted() {
    this.show = true;
  }
}
</script>